import useOnUpdate from '../../hooks/useOnUpdate';
import { IDropdownSelectButtonProps } from './dropdownSelectButton';
import FormItemWithDropdown from './formItemWithDropdown';
import { IRupInputOptions } from 'copyright-clearance-center-common-ui';
import { IFormItemBaseProps, RupInput } from 'copyright-clearance-center-common-ui-react';
import React, { useState } from 'react';

type IDropdownProps = Omit<IDropdownSelectButtonProps, 'onChange'>;
type IInputProps = Omit<IRupInputOptions, 'onChange' | 'css'>;

interface IInputWithDropdownProps extends IFormItemBaseProps {
	noForm?: boolean;
	inputProps: IInputProps;
	dropdownProps: IDropdownProps;
	onChange?: (dropdownValue: string, inputValue: string) => void;
}

const InputWithDropdown: React.FC<IInputWithDropdownProps> = ({
	noForm,
	inputProps,
	dropdownProps,
	onChange,
	...formProps
}) => {
	const [inputValue, setInputValue] = useState(inputProps.value);

	// https://react.dev/learn/you-might-not-need-an-effect#adjusting-some-state-when-a-prop-changes
	const [prevInputValueProp, setPrevInputValueProp] = useState(inputProps.value);
	if (inputProps.value !== prevInputValueProp) {
		setPrevInputValueProp(inputProps.value);
		setInputValue(inputProps.value);
	}

	useOnUpdate(() => {
		if (inputValue === inputProps.value) {
			return;
		}

		// submit change only after component has been re-rendered to escape from async DOM callback flow
		onSubmitChange(dropdownProps.value, inputValue);
	}, [inputValue]);

	const onSubmitChange = (newDropdownValue, newInputValue) => {
		onChange && onChange(newDropdownValue, newInputValue);
	};

	return (
		<>
			<FormItemWithDropdown
				noForm={noForm}
				dropdownProps={{
					...dropdownProps,
					onChange: dropdownValue => {
						onSubmitChange(dropdownValue, inputValue);
					}
				}}
				focusableElementSelector="input"
				{...formProps}
			>
				<RupInput
					noForm
					id={formProps.id}
					disabled={formProps.disabled}
					css={{
						border: 'none',
						boxShadow: 'none'
					}}
					onChange={setInputValue}
					{...inputProps}
				></RupInput>
			</FormItemWithDropdown>
		</>
	);
};

export default InputWithDropdown;
